// src/axios.js
import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE_URL;
const ImgURL = process.env.VUE_APP_IMG_URL;

// Create axios instance
const apiClient = axios.create({
  baseURL, ImgURL,// This is the base URL for API requests
  headers: {
    'Content-Type': 'application/json',
  },
});

// Export baseURL for direct use and apiClient for axios requests
export { baseURL, ImgURL };
export default apiClient;
